import axios from "axios";
import { CurrentConditions } from "./ApiResponses";

export async function getCurrentConditions(): Promise<CurrentConditions> {
  const response = await axios.get("https://api.secretsurfspot.com/current");
  const data = response.data as CurrentConditions;
  return data;
}
